// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"pl__Checkbox-module__checkbox___R3SCp"};